import React from "react";
import { Route, Routes } from "react-router";
import { Navigate } from "react-router-dom";
import { Config, AuthRoutes } from "./Config";
import Layout from "Components/Layouts/Auth/Layout";
import AuthWrapper from "Utils/Auth";
export default function Router() {
    return (
        <Routes>
            {Config.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={<route.element />}
                />
            ))}
            <Route
                path="auth/*"
                element={
                    <Layout>
                        <AuthWrapper>
                            <Routes>
                                {AuthRoutes.map((route) => (
                                    <Route
                                        key={route.path}
                                        path={route.path}
                                        element={<route.element />}
                                    />
                                ))}
                            </Routes>
                        </AuthWrapper>
                    </Layout>
                }
            />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
}
